import JustnaikAppCarousel from "./JustnaikAppCarousel";

export default JustnaikAppCarousel